import InfoIcon from '@/assets/icons/icon-info.svg'
import { Checkbox } from '@/components/ui/checkbox.tsx'
import { Tooltip } from '@/components/ui/tooltip.tsx'
import { useRestrictedWordsSettings } from '@/modules/restricted-words/hooks/use-restricted-words-settings.ts'
import { useUpdateRestrictedWordsSettings } from '@/modules/restricted-words/hooks/use-update-restricted-words-settings.ts'
import type { UpdateRestrictedWordsPayload } from '@/modules/restricted-words/types.ts'
import { classNames } from '@/utils/helpers.ts'

interface Props {
  title: string
  description: string
  fieldName: keyof UpdateRestrictedWordsPayload
}

export const RestrictedWordsSettingsItem = ({
  title,
  fieldName,
  description,
}: Props) => {
  const { updateRestrictedWordsSettings, isUpdateSettingsLoading } =
    useUpdateRestrictedWordsSettings()
  const {
    settings,
    isRestrictedWordsSettingsLoading,
    isRestrictedWordsSettingsFetching,
  } = useRestrictedWordsSettings()
  const disabled =
    isRestrictedWordsSettingsLoading ||
    isRestrictedWordsSettingsFetching ||
    isUpdateSettingsLoading

  return (
    <div className="mr-[56px] flex items-center">
      <Checkbox
        disabled={disabled}
        onCheckedChange={(val) =>
          updateRestrictedWordsSettings(fieldName, val as boolean)
        }
        className={classNames({
          'cursor-not-allowed opacity-50': disabled,
        })}
        checked={settings?.[fieldName]}
      />
      <div className="ml-1.5 flex items-center">
        <span className="text-sm text-text-default">{title}</span>
        <Tooltip content={<div>{description}</div>}>
          <div className="ml-1.5">
            <InfoIcon />
          </div>
        </Tooltip>
      </div>
    </div>
  )
}
